export enum AmendmentOptions {
    SECTION1 = 'SECTION1',
    SECTION2 = 'SECTION2',
}